import { memo } from "react";

import { QuestionPlanRoomChangeDisable } from "@/components/features/items/edit/plan/_shared/ui/components/room-change-disable";

import { useDayTripPlanRoomChangeDisable } from "./hooks";

export const QuestionDayTripPlanRoomChangeDisable = memo(() => {
	const { roomChangeDisable, onSetRoomChangeDisable } = useDayTripPlanRoomChangeDisable();

	return (
		<QuestionPlanRoomChangeDisable
			roomChangeDisable={roomChangeDisable}
			onSetRoomChangeDisable={onSetRoomChangeDisable}
		/>
	);
});

QuestionDayTripPlanRoomChangeDisable.displayName = "QuestionDayTripPlanRoomChangeDisable";
